<app-badge
  [style.cursor]="isPossibleToShowDialog ? 'pointer' : null"
  [color]="'blue'"
  [size]="isMobile ? 'm' : 'l'"
  [value]="discount"
  [tuiHint]="isDesktop ? originDiscount : ''"
  (click)="onShowDiscount($event)"
></app-badge>
